<template>
  <div class="linLongBasePage">
    <div
      :class="['msgHeader', 'clearfix', param.showMap ? '' : 'changPosition']"
    >
      <dl class="fl">
        <dt>
          <img
            :src="`${
              userData.avatar ? userData.avatar : baseUrl + 'userDefault.png'
            }`"
            alt
          />
        </dt>
        <dd class="userName">{{ userData.realName }}</dd>
        <dd class="userGarde">{{ userData.position }}</dd>
      </dl>
      <div class="fr">
        <a href="javascript:void(0);" class="phoneBtn" @click="dialMsg">
          <van-icon name="envelop-o" class="phoneIcon msgIcon" />
          
          <em class="msgText">发送信息</em>
        </a>
        <a href="javascript:void(0);" class="phoneBtn" @click="dialPhone">
          <van-icon name="phone" class="phoneIcon" />
          <em> {{ $t("linLongMsg.phoneTit") }}</em>
        </a>
      </div>
    </div>
    <div :class="['msgTab']">
      <van-tabs v-model="activeName">
        <van-tab
          :title="$t('linLongMsg.baseTit')"
          name="baseMsg"
          class="baseMsg"
        >
          <van-cell-group class="role">
            <van-field
              :value="userData.orgName ? userData.orgName : '/'"
              readonly
              :label="$t('linLongMsg.orgNameTit') + '：'"
            />
            <van-field
              :value="userData.position ? userData.position : '/'"
              readonly
              :label="$t('linLongMsg.positionTit') + '：'"
            />
            <van-field
              :value="userData.address ? userData.address : '/'"
              readonly
              :label="$t('linLongMsg.addressTit') + '：'"
            />
            <van-field
              :value="
                userData.jurisdictionName ? userData.jurisdictionName : '/'
              "
              readonly
              :label="$t('linLongMsg.jurisdictionNameTit') + '：'"
            />
            <van-field
              :value="userData.phone ? userData.phone : '/'"
              readonly
              :label="$t('linLongMsg.phonetit') + '：'"
            />
            <van-field
              :value="userData.email ? userData.email : '/'"
              readonly
              :label="$t('linLongMsg.emailTit') + '：'"
            />
          </van-cell-group>
        </van-tab>
        <van-tab
          :title="$t('linLongMsg.baseMapTit')"
          name="baseMap"
          v-if="param.showMap"
          class="baseMap"
        >
          <!-- 地图页 -->
          <!-- <zrq :param="mapData" mode="h5"></zrq> -->
          <my-zrq-list :childType="linType"></my-zrq-list>
        </van-tab>
        <!-- <van-tab :title="$t('linLongMsg.baseRecordTitle')" name="baseRecord" class="baseRecord">
          <record :userId="userData.uid"></record>
        </van-tab>
        <van-tab  :title="$t('linLongMsg.areaPolicyTitle')" name="areaPolicy" class="areaPolicy">
          <area-policy :userId="userData.uid"></area-policy>
        </van-tab> -->
      </van-tabs>
    </div>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const record = () => import("@/components/baseLinLong/baseRecord");
const areaPolicy = () => import("@/components/baseLinLong/areaPolicy");
// const zrq = () => import("@/views/map/Zrq");
const myZrqList = () =>
  import("@/components/linLongModule/linDetailModule/myZrqList");
const refreshPage = () => import("@/components/common/refreshPage");
import { getUserInfo } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "linLongMsg",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      activeName: "baseMsg", //默认选中第一项
      userId: "", //被查看人的uid
      userData: {
        //查看人基本信息
        realName: "", //姓名
        orgName: "", //单位
        position: "", //职位
        address: "", //地址
        jurisdictionName: "", //管辖范围
        phone: "", //联系电话
        email: "", //电子邮箱
        uid: "", //用户uid
      },
      mapData: {
        zrqlx: "",
        zrqobjid: "",
        toolbar: "none",
      },
      linType: "linLongMsg",
      refreshPage: false, //网络失败
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    document.title = "林长信息";
    this.clientType = getDeviceType();
    //  let winHeight = document.documentElement.clientHeight; //视口大小
    //     document.getElementById("baseMapBox").style.height = winHeight - 145 + "px";
    this.$nextTick(function () {
      this.userId = this.$route.query.commonId;

      if (JSON.stringify(this.param) === "{}") {
        this.param.showMap = true;
      }
      if (this.userId == undefined) {
        this.userId = this.param.id;
      }
      this.initPage();
    });
  },
  components: {
    refreshPage,
    // zrq,
    myZrqList,
    record,
    areaPolicy,
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal
        .linLongMsg(_this.userId)
        .then((res) => {
          if (res.code == "1") {
            _this.userData = Object.assign({}, _this.userData, res.data);
            this.initMapPage(res.data.uid);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          _this.refreshPage = true;
        });
    },
    initMapPage(id) {
      let _this = this;
      _this.$api.universal.dutyArea
        .getUserArea({
          uid: id,
        })
        .then((res) => {
          if (res.code == "1") {
            if (res.data != null) {
              this.mapData.type = res.data.tabType;
              this.mapData.objid = res.data.objid;
            }
            console.log(this.mapData);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dialPhone() {
      if (this.clientType == "android") {
        window.android.getInfo(104, this.userData.phone);
      } else {
        window.webkit.messageHandlers.getPhone.postMessage(
          String(this.userData.phone)
        );
      }
    },
    dialMsg(){
      if (this.clientType == "android") {
        window.android.getInfo(125, this.userData.phone);
      } else {
        window.webkit.messageHandlers.getPhoneMsg.postMessage(
          String(this.userData.phone)
        );
      }
    }
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;
        _this.userId = _this.param.id;
        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.linLongBasePage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;

  .msgHeader {
    width: 100%;
    padding: 15px 16px;
    background-color: #fff;
    height: 90px;
    z-index: 100;
    position: absolute;
    top: 35px;
    left: 0;
    dl {
      position: relative;
      width: 100%;

      dt {
        display: block;
        position: absolute;
        left: 0;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        -webkit-border-redius: 50%;
        -moz-border-redius: 50%;
        background: #d8d8d8;
        margin: 0 auto;

        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          -webkit-border-redius: 50%;
          -moz-border-redius: 50%;
        }
      }

      dd.userName {
        font-size: 18px;
        font-weight: 600;
      }

      dd {
        position: absolute;
        color: #333;
        left: 70px;
        top: 5px;
      }

      dd.userGarde {
        font-size: 15px;
        top: 35px;
      }
    }

    .phoneBtn {
      display: inline-block;
      width: 60px;
      height: 60px;
      position: relative;

      .phoneIcon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        -webkit-border-redius: 50%;
        -moz-border-redius: 50%;
        background-color: #35c476;
        // position: absolute;
        margin: 0 auto;
        // left: 50%;
        // margin-left: -20px;
        display: block;
        font-size: 25px;
        text-align: center;
        line-height: 40px;
        color: #fff;
        // margin-bottom: 10px;
      }
      .phoneIcon.msgIcon{
          background-color: #aaa;
      }
      em {
        display: block;
        width: 60px;
        font-weight: 400;
        font-size: 12px;
        text-align: center;
        color: #35c476;
        margin-top: 4px;
      }
      .msgText{
         color: #aaa;
      }
    }
  }

  .msgTab {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-top: 135px;

    > .van-tabs {
      width: 100%;
      height: 100%;
      padding-top: 45px;
      position: relative;
      > .van-tabs__wrap {
        width: 100%;
        height: 45px;
        position: absolute;
        top: 0;
      }
      .van-tabs__content {
        height: 100%;
        .baseRecord,
        .baseMap,
        .areaPolicy {
          height: 100%;
          > div {
            height: 100%;
          }
        }
      }

      .van-tabs__line {
        background-color: #4bc08a;
      }

      .van-tab--active {
        .van-tab__text {
          color: #4bc08a;
        }
      }

      .baseMsg {
        height: 100%;
        overflow-y: scroll;
        .van-cell {
          .van-field__label {
            color: #999;
            font-size: 14px;
          }

          .van-cell__value {
            .van-field__control {
              color: #333;
              font-size: 14px;
              text-align: right;
            }
          }
        }
      }
    }
  }
  .changPosition {
    top: 35px !important;
  }
}
</style>